import React, { useState, useEffect } from 'react';
import Title from '../../components/title/Title';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import { Link } from 'react-router-dom';
import './NotasFinanciero.css';
import { Spinner } from 'react-bootstrap';
import { formatNumber, formatDateMin } from '../../misc/index';
import Card from '../../components/Card';

const DischargeCard = ({ document }) => {
    return(
        <Card>
            <div className='card-fields-container egresos-cards-container'>
                <div className='card-field-container'>
                    <div className='card-field-title'>CENTRO DE OPERACIÓN:</div>
                    <div className='card-field-data'>{ document.idCo }</div>
                </div>
                <div className='card-field-container'>
                    <div className='card-field-title'>DOCUMENTO:</div>
                    <div className='card-field-data'>{ document.tipoDoc + '-' + document.numDoc }</div>
                </div>
                <div className='card-field-container'>
                    <div className='card-field-title'>DETALLE:</div>
                    <div className='card-field-data'>{ document.detalle }</div>
                </div>
                <div className='card-field-container'>
                    <div className='card-field-title'>FECHA DEL DOCUMENTO:</div>
                    <div>{ formatDateMin(new Date(document.fechaDoc)) }</div>
                </div>
                <div className='card-field-container'>
                    <div className='card-field-title'>VALOR DEL DOCUMENTO</div>
                    <div>${ formatNumber(document.valor) }</div>
                </div>
            </div>
        </Card>
    );
}

const NotasFinancieroView = ({ AppReducer, notas }) => {
    
    return(
        <div className='page-container'>
            <Title>Notas Contables</Title>
            {notas.loading ?
                <div className='loading-spinner'>
                    <Spinner animation="border" variant="primary" />
                </div>
            :
                <div className='page-body'>
                    <div className='desktop-view'>
                        <table className='info-table'>
                            <thead>
                                <tr>
                                    <th>CENTRO DE OPERACIÓN</th>
                                    <th>DOCUMENTO</th>
                                    <th>FECHA DEL DOCUMENTO</th>
                                    <th>DETALLE</th>
                                    <th>VALOR DEL DOCUMENTO</th>
                                    <th>VER</th>
                                    {/*<th>DESCARGAR</th>*/}
                                </tr>
                            </thead>
                            <tbody>
                                { 
                                    notas.data.map(
                                        nota => {
                                            return(
                                                <tr key={nota.id}>
                                                    <td>{ nota.idCo }</td>
                                                    <td>{ nota.tipoDoc + '-' + nota.numDoc }</td>
                                                    <td>{ formatDateMin(new Date(nota.fechaDoc)) }</td>
                                                    <td>{ nota.detalle }</td>
                                                    {/*<td>${ formatNumber(nota.debitos - nota.creditos) }</td>*/}
                                                    <td>${ formatNumber(nota.valor) }</td>
                                                    <td><div className='view-icon-container'><Link to={{ pathname: "/portal/documento-financiero-detalle", state: { documento: nota } }}><FontAwesomeIcon className='view-icon' icon={faEye} /></Link></div></td>
                                                    {/*<td><div className='pdf-icon-container' ><Link style={{ color: 'red' }} onClick={(e) => { generarEgresoDetallePdf(e, egreso) }}><FontAwesomeIcon className='view-icon' icon={faFilePdf} /></Link></div></td>*/}
                                                </tr>
                                            );
                                        }
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className='mobile-view'>
                        <div className='cards-container'>
                            {
                            notas.data.map(
                                (nota, index) => {
                                    return(
                                        <>
                                            <Link key={index} to={{ pathname: "/portal/documento-financiero-detalle", state: { documento: nota } }} ><DischargeCard key={index} document={nota} /></Link>
                                        </>
                                    );
                                }
                            )
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default NotasFinancieroView;
